<template>
    <div id="LoadingOverlay">
        <SquareLoader color='#792061' size='80px'/>
        <div class="message" v-text="message"></div>
    </div>
</template>

<script>
import SquareLoader from "vue-spinner/src/SquareLoader"

export default {
    name: "LoadingOverlay",
    props: {
        message: String
    },
    components: {
        SquareLoader
    }
}
</script>

<style scoped>
#LoadingOverlay {
    display: flex;
    position: fixed;
    justify-content: center;
    align-items: center;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100vw;
    padding: 0;
    margin: 0;
    z-index: 999999;
    background-color: rgba(255, 255, 255, 0.8);
}

#LoadingOverlay div.message {
    position: absolute;
    font-size: 2em;
    font-weight: bolder;
    color: white;
    text-shadow: 1pt 1pt 2pt #411134;
}
</style>